import LauncherFooter from './LauncherFooter';

export default LauncherFooter;
